export default __webpack_public_path__ + "static/media/audio_51_secadora_de_pelo.72dfa389.mp3";